import client from "application/apollo/apolloClient";
import includeHeaders from "application/hoc/includeHeaders";

const apolloGetQuery = (query, headers) =>
  new Promise((resolve, reject) => {
    client
      .query(includeHeaders(query, headers))
      .then((result) => resolve(result))
      .catch((err) => reject(err));
  });

export default apolloGetQuery;
